import { useEffect, useState } from "react";
import styles from './netoperatingincome.module.css'
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer, LabelList, AreaChart, Area } from 'recharts';
import { FormControl, MenuItem, Select } from '@mui/material';
import { BarChart2, TrendingUp } from 'react-feather';
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { DashCardLoaderSmall } from "../../../../../components/LoaderC";

const formatToAbbrCurrency = (amount, currency = "USD") => {
    let formatted;

    if (Math.abs(amount) >= 1.0e12) {
        formatted = (amount / 1.0e12).toFixed(1) + "T";
    } else if (Math.abs(amount) >= 1.0e9) {
        formatted = (amount / 1.0e9).toFixed(1) + "B";
    } else if (Math.abs(amount) >= 1.0e6) {
        formatted = (amount / 1.0e6).toFixed(1) + "M";
    } else if (Math.abs(amount) >= 1.0e3) {
        formatted = (amount / 1.0e3).toFixed(1) + "K";
    } else {
        formatted = amount.toFixed(2);
    }

    return '$' + formatted;

    //return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(0).replace(/\d/g, '') + formatted;
}

const NetOperatingIncome = ({ selectedProperty }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [switchGraph, setSwitchGraph] = useState(false);
    const [contentLoading, setContentLoading] = useState(true);
    const [chartData, setChartData] = useState({ total: 0, data: [] });
    const [lineData, setLineData] = useState({ total: 0, data: [] });
    const [tType, setTType] = useState('month');
    const [noData, setNoData] = useState(true);


    const SwitchGraphBU = () => {
        setSwitchGraph(!switchGraph)
    }

    useEffect(() => {
        const fetchData = async () => {
            setContentLoading(true);
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            var URL = process.env.REACT_APP_USER_API_URL + "v1/dashboard/noi-bar-data/" + tType;
            if (selectedProperty !== '' && selectedProperty > 0) {
                URL = process.env.REACT_APP_USER_API_URL + "v1/dashboard/noi-bar-data/" + tType + "?property_id=" + selectedProperty;
            }

            await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContentLoading(false);

                let totalBalance = response.data.data?.totalBalance;
                let dataArr = response.data.data?.data;

                setChartData({ total: totalBalance, data: dataArr });

                let lineDataArr = dataArr?.map(item => {
                    return { ...item, solid: item?.balance > 0 ? (item?.income - item?.expense) : null, dotted: item?.balance > 0 ? (item?.income + item?.advanced - item?.expense) : null };
                });

                setLineData({ total: totalBalance, data: lineDataArr });

                if (lineDataArr?.length > 0) {
                    setNoData(false);
                } else {
                    setNoData(true);
                }
            }).catch((error) => {
                setContentLoading(false);
            });
        }

        fetchData();
    }, [getAccessTokenSilently, selectedProperty, tType]);

    const renderCustomizedLabel = (props) => {
        const { x, y, width, index } = props;
        const radius = 10;
        let balanceData = 0;

        if (typeof (chartData?.data[index]) !== 'undefined') {
            balanceData = chartData?.data[index]?.balance;
        }

        return (balanceData > 0 ? <g>
            <text x={x + width / 2} y={y - radius} fontSize={9} fill="#363644" textAnchor="middle" dominantBaseline="middle">{formatToAbbrCurrency(balanceData)}</text>
        </g> : null);
    }

    /*const renderCustomizedLabel2 = (props) => {
        const { x, y, width, index } = props;
        const radius = 10;
        let balanceData = 0;

        if (typeof (chartData?.data[index]) !== 'undefined') {
            balanceData = chartData?.data[index]?.balance;
        }

        return (balanceData > 0 ? <g>
            <text x={x + width / 2} y={y - radius} fontSize={9} fill="#363644" textAnchor="middle" dominantBaseline="middle">{formatToAbbrCurrency(balanceData)}</text>
        </g> : null);
    }*/

    const CustomTooltip = ({ active, payload, label }) => {
        let isVisible = active && payload && payload.length;
        let netIncome = 0;
        let netExpense = 0;

        if (payload && payload.length) {
            if (payload[0]?.payload?.income === 0 && payload[0]?.payload?.expense === 0) {
                isVisible = 0;
            }

            netIncome = payload[0]?.payload?.income + payload[0]?.payload?.advanced;
            netExpense = payload[0]?.payload?.expense;
        }

        return (
            <div className={`${styles.CustomTooltip}`} style={{ visibility: isVisible ? 'visible' : 'hidden' }}>
                {isVisible && (
                    <>
                        <p className={`${styles.TooltipTitle}`}>Net Income</p>
                        <p className={`${styles.TooltipAmount}`}>{formatToAbbrCurrency(netIncome)}</p>
                        <p className={`${styles.TooltipTitle}`}>Net Expense</p>
                        <p className={`${styles.TooltipAmount}`}>{formatToAbbrCurrency(netExpense)}</p>
                    </>
                )}
            </div>
        );
    }


    return (<>
        <div className={`${styles.Card}`}>
            <div className={`${styles.InsideCard}`}>
                {contentLoading && (<div className={`${styles.LoaderDash3}`}>
                    <div><DashCardLoaderSmall /></div>
                </div>)}

                {!contentLoading && (<>
                    {!noData && (<>
                        <div className={`${styles.HeadDes}`}>
                            <div>
                                <p className={`${styles.CardTitle}`}>Net Operating Income</p>
                                <p className={`${styles.CardAmount}`}>{chartData?.total?.toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 2
                                })}</p>
                                <div className={`${styles.SelectFilterForFO} FormGroup WithOurBorder`}>
                                    <FormControl fullWidth>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            defaultValue={tType}
                                            onChange={(e) => {
                                                setTType(e.target.value);
                                            }}
                                        >
                                            <MenuItem value={'month'}>Month</MenuItem>
                                            <MenuItem value={'year'}>Year</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            <div className={`${styles.SwitchSec}`}>
                                <div className={`${styles.SwitchBU}`}>
                                    <button className={!switchGraph ? `${styles.First} ${styles.Selected}` : `${styles.First}`} onClick={SwitchGraphBU}><BarChart2 /></button>
                                </div>
                                <div className={`${styles.SwitchBU}`}>
                                    <button className={switchGraph ? `${styles.Last} ${styles.Selected}` : `${styles.Last}`} onClick={SwitchGraphBU}><TrendingUp /></button>
                                </div>
                            </div>
                        </div>
                        {!switchGraph && <ResponsiveContainer width="100%" height={220}>
                            <BarChart
                                width={500}
                                height={220}
                                data={chartData?.data}
                                margin={{
                                    top: 20,
                                    right: 0,
                                    left: 0,
                                    bottom: 6,
                                }}
                            >
                                <XAxis
                                    dataKey="label"
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fill: '#70707d', fontSize: 12, dy: 6 }}
                                />

                                <Tooltip cursor={false} content={CustomTooltip} />

                                <Bar dataKey="balance" stackId="a" fill="#502688" barSize={20}>
                                    <LabelList dataKey="label" content={renderCustomizedLabel} />
                                </Bar>
                                {/*<Bar dataKey="advanced" stackId="a" fill="#F00" barSize={20}>
                                    <LabelList dataKey="label" content={renderCustomizedLabel2} />
                                </Bar>*/}
                            </BarChart>
                        </ResponsiveContainer>}
                        {switchGraph && <ResponsiveContainer width="100%" height={220}>
                            <AreaChart
                                width={600}
                                height={220}
                                data={lineData?.data}
                                margin={{ top: 20, right: 0, left: 0, bottom: 6 }}
                            >
                                <XAxis
                                    dataKey="label"
                                    axisLine={false}
                                    tickLine={false}
                                    tick={{ fill: '#70707d', fontSize: 12, dy: 6 }}
                                    tickFormatter={(value, index) => {
                                        if (index === 0 || index === lineData?.data.length - 1) {
                                            return "";
                                        }
                                        return value;
                                    }}
                                />
                                <Tooltip cursor={false} content={CustomTooltip} />
                                <defs>
                                    <linearGradient id="myGradient" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="0%" stopColor="#502688" stopOpacity={0.7} />
                                        <stop offset="100%" stopColor="#502688" stopOpacity={0.1} />
                                    </linearGradient>
                                </defs>
                                <Area type="monotone" dataKey="solid" stroke="#502688" strokeWidth={2} fill="url(#myGradient)" dot={false} />
                                <Area type="monotone" dataKey="dotted" stroke="#502688" strokeWidth={1} strokeDasharray="5 5" fill="url(#myGradient)" fillOpacity={0.2} dot={false} />
                            </AreaChart>
                        </ResponsiveContainer>}
                    </>)}

                    {noData && (<>
                        <div className={`${styles.HeadDes}`}>
                            <div>
                                <p className={`${styles.CardTitle}`}>Net Operating Income</p>
                            </div>
                        </div>
                        <div className={`${styles.NoDataSec}`}>
                            <div className={`${styles.NoDataIMG}`}><img src="/static/img/income.png" alt="" /></div>
                            <p className={`${styles.NoDataText}`}>NOI is not available.</p>
                            <p className={`${styles.NoDataTextSub}`}>Add income and expenses to calculate NOI.</p>
                        </div>
                    </>)}

                </>)}
            </div>
        </div>
    </>);
}

export default NetOperatingIncome;